import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Popups.css';
import API_URL from '../../api/ExamCalendarApi';


const PopupsManager = () => {
  const [popups, setPopups] = useState([]);
  const [selectedPopup, setSelectedPopup] = useState(null);
  const [link, setLink] = useState('');
  const [image, setImage] = useState(null);
  const [isEditing, setIsEditing] = useState(false);


  // Fetch all popups
  const fetchPopups = async () => {
    try {
      const res = await axios.get(`${API_URL}/popups/all`);
      setPopups(res.data);
    } catch (error) {
      console.error('Error fetching popups:', error);
    }
  };

  useEffect(() => {
    fetchPopups();
  }, []);

  // Add new popup
  const addPopup = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('image', image);
    formData.append('link', link);

    try {
      await axios.post(`${API_URL}/popups/add`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      fetchPopups();
      setLink('');
      setImage(null);
    } catch (error) {
      console.error('Error adding popup:', error);
    }
  };

  // Update popup
  const updatePopup = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('image', image);
    formData.append('link', link);

    try {
      await axios.put(`${API_URL}/popups/edit/${selectedPopup._id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      fetchPopups();
      setIsEditing(false);
      setSelectedPopup(null);
      setLink('');
      setImage(null);
    } catch (error) {
      console.error('Error updating popup:', error);
    }
  };

  // Delete popup
  const deletePopup = async (id) => {
    try {
      await axios.delete(`${API_URL}/popups/delete/${id}`);
      fetchPopups();
    } catch (error) {
      console.error('Error deleting popup:', error);
    }
  };

  // Select popup to edit
  const editPopup = (popup) => {
    setSelectedPopup(popup);
    setLink(popup.link);
    setIsEditing(true);
  };

  return (
    <div className='admin-popup-container'>
      <div className="admin-popup-section">
        <h2 className="admin-popup-title">Popup Manager</h2>
        <form className="admin-popup-form" onSubmit={isEditing ? updatePopup : addPopup}>
          <div className="admin-popup-input-group">
            <label htmlFor="link" className="admin-popup-label">Link:</label>
            <input
              type="text"
              id="link"
              className="admin-popup-input"
              value={link}
              onChange={(e) => setLink(e.target.value)}
            />
          </div>
          <div className="admin-popup-input-group">
            <label htmlFor="image" className="admin-popup-label">Image:</label>
            <input
              type="file"
              id="image"
              className="admin-popup-input"
              onChange={(e) => setImage(e.target.files[0])}
            />
          </div>
          <div className="admin-popup-actions">
            <button type="submit" className="admin-popup-button">
              {isEditing ? 'Update' : 'Add'} Popup
            </button>
            {isEditing && (
              <button
                type="button"
                className="admin-popup-cancel-button"
                onClick={() => {
                  setIsEditing(false);
                  setSelectedPopup(null);
                  setLink('');
                  setImage(null);
                }}
              >
                Cancel
              </button>
            )}
          </div>
        </form>

        <h3 className="admin-popup-heading">All Popups</h3>
        <div className="admin-popup-row">
          {popups.map((popup) => (
            <div className="admin-popup-col" key={popup._id}>
              <div className="admin-popup-card">
                <img src={popup.image} alt="Popup" className="admin-popup-card-img" />
                <div className="admin-popup-card-body">
                  <p className="admin-popup-text">Link:{popup.link}</p>
                  <button className="admin-popup-edit-button" onClick={() => editPopup(popup)}>Edit</button>
                  <button className="admin-popup-delete-button" onClick={() => deletePopup(popup._id)}>Delete</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PopupsManager;
